export const socketStore = {
  state: {
    socketStatus: false
  },
  getters: {
    getSocketStatus(state) {
      return state.socketStatus;
    }
  },
  mutations: {
    setSocketStatus(state, value) {
      state.socketStatus = value;
    }
  }
};
